// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import constants from "@store/constants";
import Chat from "@store/Library/Components/Icons/Chat";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface RequestPackagingAdviceButtonPresentationProps
    extends ExpandStyles<RequestPackagingAdviceButtonStyles> {}

export interface RequestPackagingAdviceButtonProps extends RequestPackagingAdviceButtonPresentationProps {
    isLink?: boolean;
}

export interface RequestPackagingAdviceButtonStyles {
    button?: ButtonPresentationProps;
    link?: LinkPresentationProps;
}

export const requestPackagingAdviceButtonStyles: RequestPackagingAdviceButtonStyles = {
    button: {
        variant: "tertiary",
        icon: { position: "left", src: Chat },
        mergeCss: true,
        css: css`
            width: 100%;

            ${breakpoint("sm")} {
                width: auto;
            }
        `,
    },
    link: linkGetActionLinkProps(Chat),
};

const RequestPackagingAdviceButton: FC<RequestPackagingAdviceButtonProps> = ({
    isLink,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(requestPackagingAdviceButtonStyles, extendedStyles, overridedStyles);
    const history = useHistory();
    const { product } = useContext(ProductContext);
    const packagingAdviceUrl = usePageLinkByPageType(constants.pageType.packagingAdvice)?.url;

    if (!packagingAdviceUrl) {
        return null;
    }

    const redirectUrl = `${packagingAdviceUrl}?${constants.queryStringParameters.referenceProductId}=${product.id}`;
    const label = translate("Request Packaging Advice");

    return isLink ? (
        <Link {...styles.link} href={redirectUrl}>
            {label}
        </Link>
    ) : (
        <Button {...styles.button} onClick={() => history.push(redirectUrl)}>
            {label}
        </Button>
    );
};

export default RequestPackagingAdviceButton;
